import { Injectable } from '@angular/core';
import { TableColumn, TableData, TableRow } from 'app/models/table-data';

export interface TableViewData {
  columnsHeaders: string[];
  displayedColumns: string[];
  displayedRows: TableRow[];
}

export class TableViewDataGenerator {
  getTableViewData(tableData?: TableData): TableViewData {
    if (!tableData) {
      return { columnsHeaders: [], displayedColumns: [], displayedRows: [] };
    }

    const columnsHeaders: string[] = tableData.labels;

    const displayedColumns: string[] = tableData.columns;

    const displayedRows: TableRow[] = tableData.data.map((row) => ({
      cells: row.map((value) => String(value ?? '')),
    }));

    return {
      columnsHeaders,
      displayedColumns,
      displayedRows,
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class TableViewService {
  getTableViewDataGenerator(): TableViewDataGenerator {
    return new TableViewDataGenerator();
  }
}
